import ContenidoLayer from "../../components/conversacionesGlobales/ContenidoLayer";

const ContenidoPage = () => {
  return <ContenidoLayer />;
};

export default ContenidoPage;
